import { graphql } from 'react-relay';
import type { SelectorStoreUpdater } from 'relay-runtime';
import { ROOT_ID } from 'relay-runtime';

export const ChargeAdd = graphql`
  mutation ChargeAddMutation($input: ChargeAddInput!) {
    ChargeAdd(input: $input) {
      error
      charge {
        ...Order_charge
        status
        identifier
        additionalInfo {
          key
          value
        }
        value
        valueWithDiscount
        expiration
        createdAt
        correlationID
        cashback {
          value
          percentage
        }
        comment
        company {
          name
          nameFriendly
          projectType
          taxID {
            taxID
          }
          logo {
            url(fitIn: true)
          }
        }
        id
        status
        value
        valuePaid
        expiration
        isRemoved
        createdAt
        qrCodeImage
        brCode
        identifier
        valueWithDiscount
        discount
        payerIsCustomer
        paymentLinkUrl
        company {
          name
          nameFriendly
          projectType
        }
        additionalInfo {
          key
          value
        }
        customer {
          id
          name
          email
          phone
        }
        cashback {
          value
          percentage
          status
        }
        cashbackExclusive {
          value
          percentage
          status
        }
        cashbackExclusiveScheduled {
          edges {
            node {
              value
            }
          }
        }
        expiresDate
        interestsSettings {
          active
          daysAfterDueDate
          interests {
            value
            type
            modality
          }
          fines {
            value
            type
          }
        }
        decodedBrCode {
          interests
          fines
          finalValue
        }
        paymentMethods {
          ... on PaymentMethodPix {
            method
            brCode
            pixLocation
            valueWithDiscount
            identifier
          }
        }
      }
    }
  }
`;

export const updater: SelectorStoreUpdater =
  (correlationID: string) => (store) => {
    const charge = store.getRootField('ChargeAdd')?.getLinkedRecord('charge');

    if (charge) {
      // set charge to query { charge(correlationID: $correlationID) }
      store.get(ROOT_ID)?.setLinkedRecord(charge, 'charge', {
        correlationID,
      });
    }
  };
